import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstWithholdingTaxSlice = createSlice({
    name: "getAllMstWithholdingTax",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstWithholdingTaxSlice_actions = getAllMstWithholdingTaxSlice.actions;
export var fetchData = _getAllMstWithholdingTaxSlice_actions.fetchData, fetchDataSuccess = _getAllMstWithholdingTaxSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstWithholdingTaxSlice_actions.fetchDataFailure, resetState = _getAllMstWithholdingTaxSlice_actions.resetState;
export default getAllMstWithholdingTaxSlice.reducer;
